import { FETCH_TYPES } from "./Connect";
import IAjaxConnect from "./ajax/IAjaxConnect";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import { interfaces } from "inversify";
import Context = interfaces.Context;

export function connectFactory(context: Context) {
  return (type: string) => {
    switch (type) {
      case FETCH_TYPES.SETTINGS:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectSettings,
        );
      case FETCH_TYPES.ADD:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectAdd,
        );
      case FETCH_TYPES.UPDATE:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectEnd,
        );
      case FETCH_TYPES.CLOSE:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectClose,
        );
      case FETCH_TYPES.BALANCE:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectBalance,
        );
      // case FETCH_TYPES.REGULATION:
      //     return context.container.get<IAjaxConnect>(SERVICE_IDENTIFIER.ConnectRegulation);
      case FETCH_TYPES.WEBSOCKET:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectWebsocket,
        );
      case FETCH_TYPES.GET_GAME_OPT:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectGetGameOpt,
        );
      case FETCH_TYPES.SET_GAME_OPT:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectSetGameOpt,
        );
      case FETCH_TYPES.GET_DEVICE_OPT:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectGetDeviceOpt,
        );
      case FETCH_TYPES.SET_DEVICE_OPT:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectSetDeviceOpt,
        );
      case FETCH_TYPES.GET_LAST_OPTS:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectGetLastOpts,
        );
      case FETCH_TYPES.GET_SESSIONS:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectGetSessions,
        );
      case FETCH_TYPES.GET_GAME_SESSIONS:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectGetGameSessions,
        );
      case FETCH_TYPES.GET_BUTTON_OPT:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectGetButtonOpt,
        );
      case FETCH_TYPES.SET_BUTTON_OPT:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectSetButtonOpt,
        );
      case FETCH_TYPES.REPLAY:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectReplay,
        );
      case FETCH_TYPES.LOGIC:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectLogic,
        );
      case FETCH_TYPES.PLATFORM_SETTINGS:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectPlatformSettings,
        );
      case FETCH_TYPES.INIT:
      default:
        return context.container.get<IAjaxConnect>(
          SERVICE_IDENTIFIER.ConnectInit,
        );
    }
  };
}
